<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="empresas.content"
      :loading="loading"
      :server-items-length="empresas.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      :hide-default-footer="hideDefaultFooter"
      no-data-text="Nenhuma empresa encontrada"
      loading-text="Carregando empresas"
      :options="optionsList"
      >
      <template v-slot:item.logoComprador="{ item }">
        <px-input-logo small
                       v-model="item.logoComprador"
                       :public-file-path="publicFilePath"
                       :upload-path="uploadCompradorPath(item)"
                       @uploaded-image="onUploadImageComprador(item, $event)"/>
      </template>
      <template v-slot:item.pessoa.nome="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              {{ item.pessoa.nome | truncate(10) }}
            </span>
          </template>
          <span>{{ item.pessoa.nome }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.pessoa.cnpj="{ item }">
        <span>{{ item.pessoa.cnpj | cnpj }}</span>
      </template>
      <template v-slot:item.endereco="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              {{ item.endereco | endereco | truncate(75) }}
            </span>
          </template>
          <span>{{ item.endereco | endereco }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.locaisEntrega="{ item }">
        <div class="d-flex justify-center">
          <px-autocomplete-locais-entrega
            dense
            :class="`rounded-tag-small required`"
            @change="onChangeLocaisEntrega(item)"
            v-model="item.locaisEntrega"/>
        </div>
      </template>
      <template v-slot:item.filialFaturamentoPadrao="{ item }">
        <div class="d-flex justify-center">
          <v-switch
            v-model="item.filialFaturamentoPadrao"
            @change="onChangeFaturamentoPadrao(item)"
            :disabled="!hasRoleGestorCompras"/>
        </div>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  props: {
    empresas: {
      type: Object,
      default: () => ({
        content: [],
        total: 0,
      }),
    },
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
    hasRoleGestorCompras: Boolean,
    publicFilePath: String,
  },
  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15, 20],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: '',
          value: 'logoComprador',
          sortable: false,
          width: '85px',
        },
        {
          text: 'Nome',
          value: 'pessoa.nome',
          width: '125px',
        },
        {
          text: 'CNPJ',
          value: 'pessoa.cnpj',
          sortable: false,
          width: '150px',
        },
        {
          text: 'Endereco',
          value: 'endereco',
          sortable: false,
        },
        {
          text: 'Local de entrega',
          value: 'locaisEntrega',
          sortable: false,
          width: '38%',
        },
        {
          text: 'Faturamento padrão',
          value: 'filialFaturamentoPadrao',
          sortable: false,
          width: '120px',
        },
        {
          text: null,
          sortable: false,
          align: 'right',
          value: 'options',
        },
      ],
    };
  },
  methods: {
    buildEmpresa(empresa, image) {
      return {
        ...empresa,
        logoComprador: { ...image },
      };
    },
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    onChangeFaturamentoPadrao(empresa) {
      this.$emit('update-faturamento', empresa);
    },
    onChangeEntregaPadrao(empresa) {
      this.$emit('update-entrega', empresa);
    },
    onChangeLocaisEntrega(empresa) {
      this.$emit('update-locais-entrega', empresa);
    },
    onUploadImageComprador(empresa, image) {
      this.$emit('update-logo', this.buildEmpresa(empresa, image));
    },
  },
  computed: {
    hideDefaultFooter() {
      return this.empresas.total <= 10;
    },
    uploadCompradorPath() {
      return comprador => `comprador/files/public/${comprador.id}`;
    },
  },
};
</script>
